// Libraries
import React, { Fragment, useContext } from 'react';

// Services and Contexts
import LanguageContext from '../contexts/LanguageContext';

// Material-UI
import Box from '@material-ui/core/Box';
import Button from '@material-ui/core/Button';
import CssBaseline from '@material-ui/core/CssBaseline';
import { withStyles } from '@material-ui/core/styles';
import { makeStyles } from '@material-ui/core/styles';

const backgroundImages = [
  '/images/splash_a.jpg',
  '/images/splash_b.jpg',
  '/images/splash_c.jpg',
  '/images/splash_e.jpg'
];

const randomImage = (imageArray) => {
  const randomIndex = Math.floor(Math.random() * imageArray.length);
  return imageArray[randomIndex];
};

const styles = (theme) => ({
  '@global': {
    body: {
      backgroundImage: `url('${randomImage(backgroundImages)}')`,
      backgroundRepeat: 'no-repeat',
      backgroundPosition: 'center center',
      backgroundSize: 'cover',
      backgroundAttachment: 'fixed',
      height: '100vh'
    },
    html: {
      height: '100vh'
    }
  }
});

const useStyles = makeStyles((theme) => ({
  titleContainer: {
    display: 'flex',
    height: '85vh',
    alignItems: 'center',
    justifyContent: 'center',
    [theme.breakpoints.up('sm')]: {
      height: '90vh',
      justifyContent: 'left'
    }
  },
  titleBox: {
    display: 'inline-block',
    color: 'white',
    backgroundColor: 'rgba(255,255,255, 0.25)',
    fontSize: '2.5rem',
    fontWeight: 'bold',
    lineHeight: '1.3',
    textShadow: '2px 2px 2px rgba(0, 0, 0, 0.3)',
    margin: '10%',
    marginBottom: '20%',
    padding: '5%',
    [theme.breakpoints.up('sm')]: {
      fontSize: '3rem',
      lineHeight: '1.2',
      marginBottom: '10%',
      padding: '4.5%'
    },
    [theme.breakpoints.up('lg')]: {
      fontSize: '4rem',
      padding: '2.5%'
    }
  }
}));

const Splash = ({ history }) => {
  const { translate } = useContext(LanguageContext);
  const styles = useStyles();

  const renderHeading = () => {
    return translate('GLOBAL_HEADING_DMA')
      .split(' ')
      .map((word, index) => {
        return (
          <Fragment key={index}>
            {word}
            <br />
          </Fragment>
        );
      });
  };

  return (
    <Fragment>
      <CssBaseline />
      <Box className={styles.titleContainer}>
        <Box className={styles.titleBox}>
          <Box my="5%">{renderHeading()}</Box>
          <Box>
            <Button variant="contained" color="primary" onClick={() => history.push('/dma')}>
              {translate('UI_BUTTON_START_ASSESSMENT')}
            </Button>
          </Box>
        </Box>
      </Box>
    </Fragment>
  );
};

export default withStyles(styles)(Splash);
